<template>
    <div id="ComponentTransactionList">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> Part Transaction List</div>
                    <!-- Button for Clear Cache -->
                    <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                    <div class="btn-groups text-right">
                        <router-link v-if="canAddCom" class="btn btn-primary" v-bind:to="{name: 'ComponentTransactionCreate',query:{inv_id:$route.params.id}}" > <i class="fp-add"></i> Add</router-link>
                        <button type="submit" class="btn btn-secondary" v-on:click.prevent="BackInventoryList" >
                            <i class="fp-back"> </i> Back
                        </button>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content component-transaction-list">
                        <data-table-filter-config :moduleName="'componentTransactionList'" @cancelSelection="cancelAll"></data-table-filter-config>
                        <section class="data-table bg-white">
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange" :moduleName="'componentTransactionList'" :position="'top'">
                                </custom-pagination>
                                <vue-good-table
                                    ref="listComponentTransactionTable"
                                    mode="remote"
                                    title="Part Transaction"
                                    @on-page-change="onPageChange"
                                    @on-selected-rows-change="selectionChanged"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-sort-change="onSortChange"
                                    :totalRows="totalRecords"
                                    :columns="userColumns"
                                    :rows="rows"
                                    :pagination-options="{
                                        enabled: false,
                                        position: 'both',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"
                                    :select-options="{
                                    enabled: component_value,
                                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                    selectionInfoClass: 'custom-class',
                                    selectionText: 'rows selected',
                                    clearSelectionText: 'clear',
                                    }"
                                    :search-options="{
                                    enabled: false,
                                    }">
                                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                        <div :key="key">
                                            <div v-if="props.column.field == 'action'">
                                                <router-link title="Edit Part Transaction" v-if="canUpdateCom" class="fp-edit" v-bind:to="{name: 'ComponentTransactionEdit',params:{id:props.row.id}}"></router-link>
                                            </div>
                                             <div v-else-if="props.column.field == 'work_order_no'">
                                                <template v-if="canViewWo">
                                                    <a href="javascript:void(0)" title="View Work Order" v-on:click="openWo(props.row.work_order_id)" class="color-blue" >{{props.row.work_order_no}}</a>
                                                    <!-- <router-link title="View Work order" class="color-blue" v-bind:to="{name: 'WorkOrderView',params:{id:props.row.work_order_id}}">{{props.row.work_order_no}}</router-link> -->
                                                </template>
                                                <template v-else>
                                                    <span>{{props.row.work_order_no}}</span>
                                                </template>
                                            </div>
                                            <div v-else-if="props.column.field == 'receipt_number'">
                                                <template v-if="canViewPOReceipt">
                                                    <a href="javascript:void(0)" title="View Receipt" v-on:click="openReceipt(props.row.receipt_id)" class="color-blue" >{{props.row.receipt_number}}</a>
                                                    <!-- <router-link title="View Receipt" class="color-blue" v-bind:to="{name: 'RecordReceiptView',params:{id:props.row.receipt_id},query:'data='+btoa('from=comp&compid='+props.row.id)}">{{props.row.receipt_number}}</router-link> -->
                                                </template>
                                                <template v-else>
                                                    <span>{{props.row.receipt_number}}</span>
                                                </template>
                                            </div>
                                            <div v-else-if="props.column.field == 'voucher_number'">
                                                <template v-if="canViewBill">
                                                    <a href="javascript:void(0)" title="View Vendor Invoice" v-on:click="openBillView(props.row.vendor_invoice_id,'comp-trans',props.row.id)" class="color-blue" >{{props.row.voucher_number}}</a>
                                                </template>
                                                <template v-else>
                                                    <span>{{props.row.voucher_number}}</span>
                                                </template>
                                            </div>    
                                            <div v-else>
                                                {{props.formattedRow[props.column.field]}}
                                            </div>
                                        </div>
                                    </template>
                                </vue-good-table>
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange">
                                </custom-pagination>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>

import Vue from "vue";


import EventBus from "././event-bus";


import {commonMixins} from '../mixins/commonMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';

    export default {
        name: "ComponentTransactionList",
        metaInfo() {
            return {title: "Part Transaction List | " +process.env.COPYRIGHT_NAME}
        },
        mixins:[commonMixins,dataTableMixins],
        data: () => ({
            firstLoad: 0,
            permissions: [],
            cantAccessPage: "",
            userColumns:[],
            columns: [
                {
                    label: 'Part',
                    field: 'item',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Part", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },

                {
                    label: 'Location',
                    field: 'location',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"option",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Location", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Vendor',
                    field: 'vendor',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Vendor", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: '#Work Order',
                    field: 'work_order_no',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Work Order", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: '#Receipt',
                    field: 'receipt_number',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Receipt", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: '#Voucher',
                    field: 'voucher_number',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Voucher", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Quantity',
                    field: 'quantity',
                    filterable: true,
                    fpFieldType:"integer",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Quantity", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Resulting Quantity',
                    field: 'resulting_qty',
                    filterable: true,
                    fpFieldType:"integer",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Quantity", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Base Price',
                    field: 'base_price',
                    filterable: true,
                    fpFieldType:"integer",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Base Price", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Created At',
                    field: 'created_at',
                    filterable: true,
                    fpFieldType:"date",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Actions',
                    field: 'action',
                    hidden:false,
                    sortable: false,
                },
            ],
            rows: [],
            totalRecords: 0,
            component_value: false,
            loading:false,
            canUpdateCom:false,
            canAddCom:false,
            pageKey:"_component_transaction_list_",
            canViewWo:false,
            canViewPOReceipt:false,
            canViewBill:false
        }),
        watch:{

            //check permission change
            permissions: function (permissions) {

                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'list_component_transaction') {
                            self.cantAccessPage = true;
                        }
                        if (permissions[i].name == 'delete_component') {
                            self.component_value = true;
                        }
                        if (permissions[i].name == 'add_component_transaction') {
                            self.canAddCom = true;
                            self.canUpdateCom = true;
                        }
                        if (permissions[i].name == 'view_work_order') {
                            self.canViewWo = true;
                        }
                        if (permissions[i].name == 'view_purchase_order_receipt') {
                            self.canViewPOReceipt = true;
                        }
                        if (permissions[i].name == 'view_vendor_invoice') {
                            self.canViewBill = true;
                        }
                    }
                }

            }
        },
        created: function() {

        },
        mounted: function() {
            var self = this;

            //self.loadList();
            self.getPermissions();
        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.listComponentTransactionTable.unselectAllInternal();
            },

            selectionChanged(param) {
                var self = this;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },
            BackInventoryList:function(){
                var self = this;

                self.$router.push("/pdc-stock/list");
            },

            loadList() {
                var self = this;
                self.loading = true;
                var invId = 0;
                if (self.$route.params.id != undefined && self.$route.params.id > 0){
                    invId = self.$route.params.id;
                }
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    // messageData: self.message,
                    sort: self.serverParams.sort,
                    inv_id:invId
                    // exportFiltered: self.exportFilteredFlag
                };
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/component-transaction/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        // console.log(data);
                        if (data.status == "success") {
                            self.rows = data.content.row;
                            self.totalRecords = data.content.totalRecords;
                            self.filteredFlag = false;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'component-list')
                    }
                });
            },
            ItemDelete() {
                var data = this.$refs['listComponentTransactionTable'].selectedRows;
                var self = this;
                var use = [];
                for (var i = 0; i < data.length; i++) {
                    use.push(this.$refs['listComponentTransactionTable'].selectedRows[i].id)
                }

                if (confirm('Are you sure that you want to delete this Part?')) {
                    self.loading = true;
                    $("#deleteItemBtn").val("Deleting ...");
                    $.ajax({
                        url: process.env.ROOT_API + "/component/delete",
                        type: "POST",
                        data: 'id=' + use,
                        headers: this.ajxHeaders,
                        dataType: 'json',
                        success: function (data) {
                            self.loading = false;
                            setTimeout(function () {
                            $(".alert-success").removeClass("show");
                                $(".alert-success").addClass("hide");
                            }, 10000);
                            setTimeout(function () {
                                $("#deleteItemBtn").val("Delete");
                            }, 10000);
                            self.rows = data.content.row;
                            if (data.code == '200') {
                                self.rows = data.content.row;
                                self.totalRecords = data.content.totalRecords;
                                self.loadList();
                            }
                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            self.generateStatusCodeMessage(jqXHR,true,'component-delete')
                        }
                    });
                }
            },
            openBillView(billId) {
                var self = this;
                var fromUrl = btoa(window.location.pathname);
                self.$router.push("/vendor-invoice/view/"+billId+"?fromUrl="+fromUrl);
            },

            openReceipt(rcId) {
                var self = this;
                var fromUrl = btoa(window.location.pathname);
                self.$router.push("/record-receipt/view/"+rcId+"?fromUrl="+fromUrl);
            },
            openWo(woId) {
                var self = this;
                var fromUrl = btoa(window.location.pathname);
                self.$router.push("/workorder/view/"+woId+"?fromUrl="+fromUrl);
            }

        }
    };
</script>



// WEBPACK FOOTER //
// src/components/ComponentTransactionList.vue